import React from 'react';

const Ogolne = (props) => {
  return (
    <React.Fragment>
      <h5 className="page-header firstColor">
        <b>Grupowe Ubezpieczenie TUW PZUW Opieka Medyczna</b> to profesjonalna{' '}
        <b>opieka medyczna</b> <br />w renomowanych placówkach medycznych w
        całej Polsce dla Ciebie i członków Twojej rodziny.
      </h5>

      <div className="secondColor">
        <p>
          Zarówno <b>pracownicy, współpracownicy</b> jak i{' '}
          <b>byli pracownicy</b> mają możliwość objęcia ubezpieczeniem{' '}
          <b>dorosłych dzieci</b> w zakresie <b>Komfort</b>.
        </p>
      </div>

      <p className="firstColor">
        Zakres pakietu dla dorosłego dziecka jest identyczny z zakresem{' '}
        <b>Komfort</b> dla pracownika lub współpracownika.
      </p>

      <p className="secondColor">
        Jeśli chcesz ubezpieczyć dorosłe dziecko, możesz wybrać dla siebie{' '}
        <b>inny wariant pakietu</b> — np. dla dziecka <b>Komfort</b>, a dla
        siebie <b>Komfort Plus</b> lub <b>Optimum</b>.
      </p>

      <div className="alert alert-warning mt-3 secondColor">
        <b>Ważne:</b> Aby zgłosić dorosłe dziecko do ubezpieczenia, musisz
        posiadać aktywny pakiet opieki medycznej.
      </div>

      <br />
      <b className="firstColor">Wiek uprawniający do objęcia ubezpieczeniem</b>
      <ul className="secondColor">
        <li>
          <b>dorosłe dziecko</b> – dziecko własne lub przysposobione pracownika,
          współpracownika, byłego pracownika lub jego partnera życiowego, które
          ukończyło 26 rok życia
        </li>
      </ul>

      <br />
      <div className="text-white p-2 sixthColor iconFromLeft moneyIcon">
        <h5 className="firstColor">
          <b>Składka za ubezpieczenie (opłata za miesiąc)</b>
        </h5>
      </div>

      <br />
      <table className="table table-striped table-condensed secondColor">
        <tbody>
          <tr>
            <th className="text-center">Pakiet / zakres</th>
            <th className="text-center">Komfort</th>
          </tr>
          <tr>
            <th className="text-center">Dorosłe Dziecko Pracownik</th>
            <td className="text-center">327,70 zł</td>
          </tr>
          <tr>
            <th className="text-center">Dorosłe Dziecko Współpracownik</th>
            <td className="text-center">385,50 zł</td>
          </tr>
        </tbody>
      </table>

      <br />
      <p className="secondColor">
        Składka za ubezpieczenie płatna jest na numer subkonta bankowego
        wskazanego na deklaracji przystąpienia do ubezpieczenia.
      </p>
    </React.Fragment>
  );
};

export default Ogolne;
